export var HomeTabsType;
(function (HomeTabsType) {
    HomeTabsType[HomeTabsType["OFFER"] = 0] = "OFFER";
    HomeTabsType[HomeTabsType["COURSES"] = 1] = "COURSES";
    HomeTabsType[HomeTabsType["HISTORY"] = 2] = "HISTORY";
    HomeTabsType[HomeTabsType["MOODLE"] = 3] = "MOODLE";
})(HomeTabsType || (HomeTabsType = {}));
